import { render, staticRenderFns } from "./MenuAccess.vue?vue&type=template&id=a50a8ed6&"
import script from "./MenuAccess.vue?vue&type=script&lang=js&"
export * from "./MenuAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports